import api from './api';

export interface UiSettings {
  timerText: string;
  timerDurationInMinutes: number;
  timerExpiredText: string;
  toastDurationInMs: number;
  onboardingSteps: {
    general: string;
    childData: string;
    discovery: string;
    final: string;
  };
  facebookAccessToken?: string;
  facebookPixel?: string;
  tiktokPixel?: string;
  utmfyToken?: string;
}

export const UiSettingsService = {
  async get(): Promise<UiSettings> {
    const response = await api.get('/ui-settings');
    return response.data.data;
  },
};
